import { LoadablePaint } from '@confluence/loadable';

export const ContentTools = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTools" */ '../src/ContentTools.tsx'))
			.ContentTools,
});
